import {makeStyles, Theme} from "@material-ui/core";

type Props = {
  background: string;
};
const useStyles = makeStyles<Theme, Props>((theme: Theme) => ({
    root: {
      maxWidth: 1200,
      margin: "0 auto",
      boxSizing: "border-box",
    },
    background: {
      background: "linear-gradient(135deg, #0F172A 0%, #1E1B4B 50%, #312E81 100%)",
      borderRadius: 24,
      padding: "32px 36px",
      color: "#FFFFFF",
      marginBottom: 28,
      position: "relative",
      overflow: "hidden",
      boxShadow: "0 12px 32px rgba(15, 23, 42, 0.15)",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "wrap",
      gap: 20,
      minHeight: 120,
      boxSizing: "border-box",
      [theme.breakpoints?.down("sm")]: {
        padding: "20px 18px",
        borderRadius: 16,
        minHeight: "auto",
      },
      "&::after": {
        content: '""',
        position: "absolute",
        top: "-40%",
        right: "-10%",
        width: 300,
        height: 300,
        background: "radial-gradient(circle, rgba(99, 102, 241, 0.25) 0%, rgba(99, 102, 241, 0) 70%)",
        pointerEvents: "none",
      },
      "& >h6": {
        color: "#FFFFFF !important",
        fontSize: "1.75rem !important",
        fontWeight: "800 !important",
        margin: "0 !important",
        position: "relative !important",
        left: "auto !important",
        top: "auto !important",
        bottom: "auto !important",
        zIndex: 2,
        [theme.breakpoints?.down("sm")]: {
          fontSize: "1.25rem !important",
        },
      },
    },
      container: {
        maxHeight: 600,
        [theme.breakpoints?.down("sm")]: {
          display: "none",
        },
      },
      filterToolbar: {
        position: "sticky",
        top: 76,
        zIndex: 10,
        backdropFilter: "blur(12px)",
        backgroundColor: "rgba(255, 255, 255, 0.85)",
        borderRadius: 16,
        padding: "12px 20px",
        marginBottom: 20,
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.04)",
        border: "1px solid #E2E8F0",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 16,
        flexWrap: "wrap",
        transition: "all 0.25s ease",
        [theme.breakpoints?.down("sm")]: {
          top: 68,
          padding: "12px 14px",
          borderRadius: 12,
        },
        "& .MuiOutlinedInput-root": {
          height: 42,
          borderRadius: 10,
          backgroundColor: "#FFFFFF",
        },
      },
      stickyActive: {
        backgroundColor: "#FFFFFF !important",
        boxShadow: "0 10px 25px -5px rgba(15, 23, 42, 0.1) !important",
      },
      sortGroup: {
        display: "flex",
        alignItems: "center",
        gap: 10,
        [theme.breakpoints?.down("sm")]: {
          width: "100%",
          justifyContent: "space-between",
        },
      },
      btnSortDirection: {
        height: 42,
        borderRadius: 10,
        backgroundColor: "#F1F5F9",
        color: "#334155",
        fontWeight: 700,
        fontSize: "0.8125rem",
        textTransform: "none",
        padding: "0 14px",
        border: "1px solid #CBD5E1",
        "&:hover": {
          backgroundColor: "#E2E8F0",
        },
      },
      btn_detail: {
        color: "#4F46E5",
        backgroundColor: "#EEF2FF",
        borderRadius: 8,
        fontSize: 12,
        fontWeight: 700,
        padding: "6px 14px",
        margin: "0 4px",
        border: "none",
        cursor: "pointer",
        textTransform: "none",
        transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
        "&:hover": {
          backgroundColor: "#4F46E5",
          color: "#FFFFFF",
          boxShadow: "0 4px 12px rgba(79, 70, 229, 0.25)",
        },
      },
      btn_edit: {
        color: "#0284C7",
        backgroundColor: "#F0F9FF",
        borderRadius: 8,
        fontSize: 12,
        fontWeight: 700,
        padding: "6px 14px",
        margin: "0 4px",
        border: "none",
        cursor: "pointer",
        textTransform: "none",
        transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
        "&:hover": {
          backgroundColor: "#0284C7",
          color: "#FFFFFF",
          boxShadow: "0 4px 12px rgba(2, 132, 199, 0.25)",
        },
      },
      btn_delete: {
        color: "#DC2626",
        backgroundColor: "#FEF2F2",
        borderRadius: 8,
        fontSize: 12,
        fontWeight: 700,
        padding: "6px 14px",
        margin: "0 4px",
        border: "none",
        cursor: "pointer",
        textTransform: "none",
        transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
        "&:hover": {
          backgroundColor: "#DC2626",
          color: "#FFFFFF",
          boxShadow: "0 4px 12px rgba(220, 38, 38, 0.25)",
        },
      },
      mobileListView: {
        display: "none",
        [theme.breakpoints?.down("sm")]: {
          display: "block",
          padding: "20px 10px",
        },
      },
      mobileCard: {
        backgroundColor: "#FFFFFF",
        borderRadius: 16,
        border: "1px solid #E2E8F0",
        padding: 16,
        marginBottom: 12,
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.02)",
      },
      mobileCardHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 12,
      },
      mobileCardBody: {
        display: "flex",
        flexDirection: "column",
        gap: 8,
        marginBottom: 14,
        backgroundColor: "#F8FAFC",
        padding: "12px 14px",
        borderRadius: 10,
      },
      mobileCardRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      },
      mobileCardActions: {
        display: "flex",
        gap: 8,
        justifyContent: "flex-end",
        flexWrap: "wrap",
      },
      paginationContainer: {
        marginTop: 24,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: "#FFFFFF",
        padding: "16px 24px",
        borderRadius: 16,
        border: "1px solid #E2E8F0",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.02)",
        [theme.breakpoints?.down("sm")]: {
          flexDirection: "column",
          gap: 12,
          padding: "16px 12px",
          borderRadius: 12,
        },
      },
}));

export default useStyles;
